import WOW from "wow.js";

export const initAnimations = () => {
  document.getElementById("body").classList.remove("loading");
  new WOW().init();
};
